export default __webpack_public_path__ + "static/media/forensic-audit.e4311c43.svg";